import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { "element-loading-background": "rgba(0, 0, 0, 0.5)" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"red","font-size":"14px","margin-bottom":"15px"}
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { style: {"width":"100%","word-break":"break-all","text-align":"center","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  style: {"cursor":"pointer","width":"100%","word-break":"break-all","text-align":"center","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_11 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"center","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  style: {"color":"green"}
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { style: {"width":"100%","word-break":"break-all","text-align":"center","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { style: {"width":"100%","word-break":"break-all","text-align":"center","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { style: {"font-size":"13px","color":"#fe995b","font-weight":"900","padding-top":"15px"} }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, "历史记录", -1)
const _hoisted_30 = { style: {"float":"right"} }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { style: {"font-size":"13px"} }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { style: {"float":"left"} }
const _hoisted_35 = { style: {"font-weight":"900"} }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 0,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_38 = {
  key: 1,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_40 = {
  key: 0,
  style: {"text-indent":"20px","line-height":"28px"}
}
const _hoisted_41 = {
  key: 0,
  style: {"clear":"both"}
}
const _hoisted_42 = {
  key: 0,
  style: {"float":"left"}
}
const _hoisted_43 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_44 = {
  key: 0,
  style: {}
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { style: {"font-weight":"900"} }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { style: {"font-weight":"900"} }
const _hoisted_51 = ["href"]
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { style: {"font-weight":"900"} }
const _hoisted_54 = { key: 2 }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { style: {"font-weight":"900"} }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { style: {"font-weight":"900"} }
const _hoisted_59 = ["href"]
const _hoisted_60 = { key: 3 }
const _hoisted_61 = { style: {} }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { style: {"font-weight":"900"} }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { style: {"font-weight":"900"} }
const _hoisted_69 = { key: 2 }
const _hoisted_70 = { style: {"font-weight":"900"} }
const _hoisted_71 = { key: 3 }
const _hoisted_72 = { style: {} }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_75 = {
  key: 1,
  style: {"clear":"both"}
}
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { style: {"font-weight":"900"} }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { style: {"font-weight":"900"} }
const _hoisted_81 = { key: 2 }
const _hoisted_82 = { style: {"font-weight":"900"} }
const _hoisted_83 = { key: 3 }
const _hoisted_84 = { style: {} }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = {
  key: 0,
  style: {"float":"left"}
}
const _hoisted_87 = {
  key: 1,
  style: {"float":"left"}
}
const _hoisted_88 = { style: {"float":"left","text-indent":"20px"} }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { style: {"font-weight":"900"} }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = { style: {"font-weight":"900"} }
const _hoisted_93 = { key: 2 }
const _hoisted_94 = { style: {"font-weight":"900"} }
const _hoisted_95 = { key: 3 }
const _hoisted_96 = { style: {} }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_99 = {
  key: 1,
  style: {"height":"40px","line-height":"40px","text-align":"center","font-size":"14px","color":"#999"}
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 执行人 ", -1)
const _hoisted_101 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_102 = { style: {"clear":"both","height":"25px"} }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 报关单号 ", -1)
const _hoisted_104 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_105 = { style: {"clear":"both","height":"25px"} }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 海关放行时间 ", -1)
const _hoisted_107 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_108 = { style: {"clear":"both","height":"25px"} }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 修改提运单号 ", -1)
const _hoisted_110 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_111 = { style: {"clear":"both","height":"25px"} }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 修改提运单号 ", -1)
const _hoisted_113 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_114 = ["title"]
const _hoisted_115 = ["title"]
const _hoisted_116 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1)
const _hoisted_117 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_118 = { style: {"clear":"both","height":"25px","margin-top":"20px"} }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 添加 ", -1)
const _hoisted_120 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_121 = { style: {"clear":"both","height":"25px"} }
const _hoisted_122 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_125 = {
  cellpadding: "0",
  cellspacing: "0",
  class: "tbAnnex",
  style: {"width":"100% !important","margin-top":"-3px"}
}
const _hoisted_126 = { style: {"font-size":"14px","height":"40px","width":"90% !important"} }
const _hoisted_127 = ["href"]
const _hoisted_128 = {
  cellpadding: "0",
  cellspacing: "0",
  class: "tbAnnex",
  style: {"width":"100% !important"}
}
const _hoisted_129 = { style: {"font-size":"14px","height":"40px","width":"90% !important"} }
const _hoisted_130 = { style: {"line-height":"40px"} }
const _hoisted_131 = { style: {"font-size":"12px","cursor":"pointer","color":"#409eff","width":"10% !important","text-align":"right"} }
const _hoisted_132 = { style: {"line-height":"40px"} }
const _hoisted_133 = { key: 1 }
const _hoisted_134 = { key: 1 }
const _hoisted_135 = { key: 1 }
const _hoisted_136 = { style: {"clear":"both","height":"25px"} }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 附件 ", -1)
const _hoisted_138 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_139 = {
  cellpadding: "0",
  cellspacing: "0",
  class: "tbAnnex",
  style: {"width":"100% !important"}
}
const _hoisted_140 = { style: {"font-size":"14px","height":"40px","width":"90% !important"} }
const _hoisted_141 = { style: {"font-size":"12px","cursor":"pointer","color":"#409eff","width":"10% !important","text-align":"center"} }
const _hoisted_142 = ["href"]
const _hoisted_143 = { key: 1 }
const _hoisted_144 = { key: 1 }
const _hoisted_145 = { key: 1 }
const _hoisted_146 = { style: {"clear":"both","height":"25px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_order_summary_time = _resolveComponent("order-summary-time")!
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Document = _resolveComponent("Document")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_miezz_supplier = _resolveComponent("miezz-supplier")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createVNode(_component_miezz_menu_tab, {
        modelValue: _ctx.menuTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
      }, {
        center: _withCtx(() => [
          _createVNode(_component_order_summary_time, { id: _ctx._orderId }, null, 8, ["id"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          (_ctx.list.Data?.UseThreeApiService)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createTextVNode(" 在"),
                _createElementVNode("a", {
                  href: `/#/order/main-bill/edit/${_ctx.list.Data.OrderId}?backUrl=${_ctx.$route.fullPath}`
                }, "主单信息", 8, _hoisted_3),
                _createTextVNode("中填入提单号码、承运人后，此处填写提运单号信息可自动获取相应信息（标题绿色） ")
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table, {
            data: _ctx.list.Data.Items,
            ref: "customsTable",
            stripe: "",
            style: {"width":"100%"},
            "header-cell-style": { 'text-align': 'center' },
            "cell-style": _ctx.cellClassName,
            "row-style": _ctx.rowStyle,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "Code",
                label: "编号",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.isString(scope.row.Code)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "BLNO",
                label: "提运单号",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  (_ctx.isEdit == true)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.onBLNO(scope.row))
                      }, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: scope.row.BLNO ? scope.row.BLNO : '暂无数据',
                          style: _normalizeStyle(scope.row.BLNO ? 'color: #409EFF' : 'color: #fe995b')
                        }, null, 8, ["text", "style"])
                      ], 8, _hoisted_5))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: scope.row.BLNO ? scope.row.BLNO : '暂无数据'
                        }, null, 8, ["text"])
                      ]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "BLNO",
                label: "报关单号",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  (_ctx.isEdit == true)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.editCustomsCode(scope.row))
                      }, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: scope.row.CustomsCode ? scope.row.CustomsCode : '暂无数据',
                          style: _normalizeStyle(scope.row.BLNO ? 'color: #409EFF' : 'color: #fe995b')
                        }, null, 8, ["text", "style"])
                      ], 8, _hoisted_7))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: scope.row.CustomsCode ? scope.row.CustomsCode : '暂无数据'
                        }, null, 8, ["text"])
                      ]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "ClientCompany",
                label: "委托人",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  (scope.row.ClientCompany != null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_ctx.isEdit == true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.isString(scope.row.ClientCompany.NameZh)), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.isString(scope.row.ClientCompany.NameZh)), 1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "Supplier",
                label: "供应商",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  (_ctx.isEdit == true && _ctx.logier.DisabledReadSupplier != true)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.onSupplier(scope.row))
                      }, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: scope.row.Supplier ? scope.row.Supplier : '暂无数据',
                          style: _normalizeStyle(scope.row.Supplier ? 'color: #409EFF' : 'color: #fe995b'
                )
                        }, null, 8, ["text", "style"])
                      ], 8, _hoisted_12))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: scope.row.Supplier ? scope.row.Supplier : '暂无数据'
                        }, null, 8, ["text"])
                      ]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "Executor",
                label: "执行人",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  (_ctx.isEdit == true)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.onExecutor(scope.row))
                      }, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: scope.row.Executor ? scope.row.Executor : '暂无数据',
                          style: _normalizeStyle(scope.row.Executor ? 'color: #409EFF' : 'color: #fe995b'
                )
                        }, null, 8, ["text", "style"])
                      ], 8, _hoisted_14))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: scope.row.Executor ? scope.row.Executor : '暂无数据'
                        }, null, 8, ["text"])
                      ]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "ReleaseTimeString",
                "show-overflow-tooltip": true
              }, {
                header: _withCtx(() => [
                  (_ctx.list.Data?.UseThreeApiService)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, "海关放行时间"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, "海关放行时间"))
                ]),
                default: _withCtx((scope) => [
                  (
              _ctx.isEdit == true &&
              !scope.row.BindThreeApiPropList.contains('ReleaseTime')
            )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.onReleaseTime(scope.row))
                      }, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: scope.row.ReleaseTimeString
                ? scope.row.ReleaseTimeString
                : '暂无数据'
                ,
                          style: _normalizeStyle(scope.row.ReleaseTimeString
                  ? 'color: #409EFF'
                  : 'color: #fe995b'
                  )
                        }, null, 8, ["text", "style"])
                      ], 8, _hoisted_18))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: scope.row.ReleaseTimeString
                ? scope.row.ReleaseTimeString
                : '暂无数据'
                
                        }, null, 8, ["text"])
                      ]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "AnnexString",
                label: "附件"
              }, {
                default: _withCtx((scope) => [
                  (_ctx.isEdit == true)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.onAnnex(scope.row))
                      }, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: scope.row.AnnexString ? scope.row.AnnexString : '暂无数据'
                ,
                          style: _normalizeStyle(scope.row.AnnexString && scope.row.AnnexString != '暂无数据'
                  ? 'color: #409EFF'
                  : 'color: #fe995b'
                  )
                        }, null, 8, ["text", "style"])
                      ], 8, _hoisted_20))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.onAnnex(scope.row))
                      }, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: scope.row.AnnexString ? scope.row.AnnexString : '暂无数据'
                
                        }, null, 8, ["text"])
                      ], 8, _hoisted_21))
                ]),
                _: 1
              }),
              (_ctx.service == 10)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    prop: "IsTax",
                    label: "是否退税",
                    width: "90px"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_22, [
                        (scope.row.IsTax == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "是"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, "否"))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.service == 20)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 1,
                    prop: "IsTax",
                    label: "清关抬头",
                    width: "150px",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(scope.row.DestinationPortCustomsClearanceHeaderProvider), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, {
                prop: "Code",
                label: "进程",
                width: "90px"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.onProcess(scope.row)),
                    style: {"cursor":"pointer","color":"#409eff","width":"100%","word-break":"break-all","text-align":"center","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
                  }, " 查看详情 ", 8, _hoisted_26)
                ]),
                _: 1
              }),
              (_ctx.isDelete == true)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 2,
                    prop: "Executor",
                    label: "操作",
                    width: "80"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (_ctx.onDelete(scope.row)),
                        title: "删除"
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Delete)
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_27)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data", "cell-style", "row-style"]),
          _createElementVNode("div", _hoisted_28, [
            (_ctx.isAdd == true)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  style: {"cursor":"pointer"},
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAdd && _ctx.onAdd(...args)))
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Plus)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" 添加")
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      (_ctx.logier?.CompanyType != _ctx.EnumCompanyType.Customer)
        ? (_openBlock(), _createBlock(_component_el_card, {
            key: 0,
            style: {"margin-top":"5px"}
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", {
                style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isHistory = !_ctx.isHistory))
              }, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  (_ctx.isHistory == false)
                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ArrowDownBold)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ArrowUpBold)
                        ]),
                        _: 1
                      }))
                ])
              ]),
              (_ctx.isHistory == false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    (
            _ctx.historys.Data.Items != null &&
            _ctx.historys.Data.Items != undefined &&
            _ctx.historys.Data.Items.length > 0
          )
                      ? (_openBlock(), _createBlock(_component_el_timeline, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historys.Data.Items, (activity, index) => {
                              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                key: index,
                                timestamp: activity.CreatedTime,
                                "hide-timestamp": true
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", {
                                      style: {"cursor":"pointer"},
                                      onClick: ($event: any) => (activity.IsOpen = !activity.IsOpen)
                                    }, [
                                      _createElementVNode("div", _hoisted_34, [
                                        _createTextVNode(_toDisplayString(activity.CreatedTime) + " 由", 1),
                                        _createElementVNode("span", _hoisted_35, _toDisplayString(activity.CreatedUserName) + "（" + _toDisplayString(activity.CreatedCompanyNameZh) + "）", 1),
                                        _createTextVNode(_toDisplayString(activity.Title), 1),
                                        (
                      activity.NewLabel != null &&
                      activity.NewLabel != undefined &&
                      activity.NewLabel != ''
                    )
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, "（" + _toDisplayString(activity.NewLabel) + "）", 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (
                    activity.IsOpen == false &&
                    activity.Child != null &&
                    activity.Child != undefined &&
                    activity.Child.length > 0
                  )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Plus)
                                              ]),
                                              _: 1
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      (
                    activity.IsOpen == true &&
                    activity.Child != null &&
                    activity.Child != undefined &&
                    activity.Child.length > 0
                  )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Minus)
                                              ]),
                                              _: 1
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      _hoisted_39
                                    ], 8, _hoisted_33),
                                    (
                  activity.Child != null &&
                  activity.Child != undefined &&
                  activity.Child.length > 0 &&
                  activity.IsOpen == true
                )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.Child, (p, index1) => {
                                            return (_openBlock(), _createElementBlock("div", { key: index1 }, [
                                              (
                      p.Title != null && p.Title != undefined && p.Title != ''
                    )
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                    (
                        p.Child != null &&
                        p.Child != undefined &&
                        p.Child.length > 0
                      )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(p.Title), 1))
                                                      : _createCommentVNode("", true),
                                                    (
                        p.Child != null &&
                        p.Child != undefined &&
                        p.Child.length > 0
                      )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                          (
                          p.Child != null &&
                          p.Child != undefined &&
                          p.Child.length > 0
                        )
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p2, index2) => {
                                                                  return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                                                                    (
                              p2.Child == null ||
                              p2.Child == undefined ||
                              p2.Child.length <= 0
                            )
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                                          (p2.State == 4)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                                                (p2.IsUrl != true)
                                                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                                                                                      _createTextVNode(" 新增了"),
                                                                                      _createElementVNode("span", _hoisted_48, _toDisplayString(p2.Label), 1),
                                                                                      _createTextVNode("，新值为\"" + _toDisplayString(p2.NewLabel) + "\" ", 1)
                                                                                    ]))
                                                                                  : (_openBlock(), _createElementBlock("span", _hoisted_49, [
                                                                                      _createTextVNode(" 新增了"),
                                                                                      _createElementVNode("span", _hoisted_50, _toDisplayString(p2.Label), 1),
                                                                                      _createTextVNode("，新值为\""),
                                                                                      _createElementVNode("a", {
                                                                                        href: _ctx.onUrl(p2.NewLabel),
                                                                                        target: "_blank"
                                                                                      }, _toDisplayString(p2.NewLabel), 9, _hoisted_51),
                                                                                      _createTextVNode("\" ")
                                                                                    ]))
                                                                              ]))
                                                                            : _createCommentVNode("", true),
                                                                          (p2.State == 3)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                                                _createTextVNode(" 编辑了"),
                                                                                _createElementVNode("span", _hoisted_53, _toDisplayString(p2.Label), 1),
                                                                                _createTextVNode("，由\"" + _toDisplayString(p2.OldLabel) + "\"改为\"" + _toDisplayString(p2.NewLabel) + "\" ", 1)
                                                                              ]))
                                                                            : _createCommentVNode("", true),
                                                                          (p2.State == 2)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                                                (p2.IsUrl != true)
                                                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                                                                                      _createTextVNode(" 删除了"),
                                                                                      _createElementVNode("span", _hoisted_56, _toDisplayString(p2.Label), 1),
                                                                                      _createTextVNode("，原值为\"" + _toDisplayString(p2.NewLabel) + "\" ", 1)
                                                                                    ]))
                                                                                  : (_openBlock(), _createElementBlock("span", _hoisted_57, [
                                                                                      _createTextVNode(" 删除了"),
                                                                                      _createElementVNode("span", _hoisted_58, _toDisplayString(p2.Label), 1),
                                                                                      _createTextVNode("，原值为\""),
                                                                                      _createElementVNode("a", {
                                                                                        href: _ctx.onUrl(p2.NewLabel),
                                                                                        target: "_blank"
                                                                                      }, _toDisplayString(p2.NewLabel), 9, _hoisted_59),
                                                                                      _createTextVNode("\" ")
                                                                                    ]))
                                                                              ]))
                                                                            : _createCommentVNode("", true),
                                                                          (p2.State == 999)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                                                _createElementVNode("span", _hoisted_61, "未编辑" + _toDisplayString(p2.Label), 1),
                                                                                _createTextVNode("，原值为\"" + _toDisplayString(p2.OldLabel) + "\" ", 1)
                                                                              ]))
                                                                            : _createCommentVNode("", true)
                                                                        ]))
                                                                      : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                                          (
                                p2.Title != null &&
                                p2.Title != undefined &&
                                p2.Title != ''
                              )
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(p2.Title), 1))
                                                                            : (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(p2.NewLabel), 1))
                                                                        ])),
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p2.Child, (p3, index3) => {
                                                                      return (_openBlock(), _createElementBlock("div", {
                                                                        key: index3,
                                                                        style: {"text-indent":"20px","line-height":"28px"}
                                                                      }, [
                                                                        (p3.State == 4)
                                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_65, [
                                                                              _createTextVNode("新增了"),
                                                                              _createElementVNode("span", _hoisted_66, _toDisplayString(p3.Label), 1),
                                                                              _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                            ]))
                                                                          : _createCommentVNode("", true),
                                                                        (p3.State == 3)
                                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_67, [
                                                                              _createTextVNode("编辑了"),
                                                                              _createElementVNode("span", _hoisted_68, _toDisplayString(p3.Label), 1),
                                                                              _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                            ]))
                                                                          : _createCommentVNode("", true),
                                                                        (p3.State == 2)
                                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                                                                              _createTextVNode("删除了"),
                                                                              _createElementVNode("span", _hoisted_70, _toDisplayString(p3.Label), 1),
                                                                              _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                            ]))
                                                                          : _createCommentVNode("", true),
                                                                        (p3.State == 999)
                                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                                                                              _createElementVNode("span", _hoisted_72, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                              _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                            ]))
                                                                          : _createCommentVNode("", true)
                                                                      ]))
                                                                    }), 128))
                                                                  ]))
                                                                }), 128))
                                                              ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_73, "—"))
                                                        ]))
                                                      : _createCommentVNode("", true),
                                                    _hoisted_74
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                                    (
                        p.Child == null ||
                        p.Child == undefined ||
                        p.Child.length <= 0
                      )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                                          (p.State == 4)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_77, [
                                                                _createTextVNode("新增了"),
                                                                _createElementVNode("span", _hoisted_78, _toDisplayString(p.Label), 1),
                                                                _createTextVNode("，新值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                              ]))
                                                            : _createCommentVNode("", true),
                                                          (p.State == 3)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_79, [
                                                                _createTextVNode("编辑了"),
                                                                _createElementVNode("span", _hoisted_80, _toDisplayString(p.Label), 1),
                                                                _createTextVNode("，由\"" + _toDisplayString(p.OldLabel) + "\"改为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                              ]))
                                                            : _createCommentVNode("", true),
                                                          (p.State == 2)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_81, [
                                                                _createTextVNode("删除了"),
                                                                _createElementVNode("span", _hoisted_82, _toDisplayString(p.Label), 1),
                                                                _createTextVNode("，原值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                              ]))
                                                            : _createCommentVNode("", true),
                                                          (p.State == 999)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_83, [
                                                                _createElementVNode("span", _hoisted_84, "未编辑" + _toDisplayString(p.Label), 1),
                                                                _createTextVNode("，原值为\"" + _toDisplayString(p.OldLabel) + "\"", 1)
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                                          (
                          p.Title != null &&
                          p.Title != undefined &&
                          p.Title != ''
                        )
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(p.Title), 1))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_87, _toDisplayString(p.NewLabel), 1)),
                                                          _createElementVNode("div", _hoisted_88, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p3, index3) => {
                                                              return (_openBlock(), _createElementBlock("div", {
                                                                style: {"clear":"both"},
                                                                key: index3
                                                              }, [
                                                                (p3.State == 4)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                                                      _createTextVNode(" 新增了"),
                                                                      _createElementVNode("span", _hoisted_90, _toDisplayString(p3.Label), 1),
                                                                      _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\" ", 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (p3.State == 3)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                                                      _createTextVNode(" 编辑了"),
                                                                      _createElementVNode("span", _hoisted_92, _toDisplayString(p3.Label), 1),
                                                                      _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\" ", 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (p3.State == 2)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                                                      _createTextVNode(" 删除了"),
                                                                      _createElementVNode("span", _hoisted_94, _toDisplayString(p3.Label), 1),
                                                                      _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\" ", 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (p3.State == 999)
                                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_95, [
                                                                      _createElementVNode("span", _hoisted_96, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                      _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                              ]))
                                                            }), 128)),
                                                            _hoisted_97
                                                          ]),
                                                          _hoisted_98
                                                        ]))
                                                  ]))
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["timestamp"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_99, " 暂无数据 ")),
                    (
            _ctx.historys.Data.Items != null &&
            _ctx.historys.Data.Items != undefined &&
            _ctx.historys.Data.Items.length > 0 &&
            _ctx.historys.Data.Total > _ctx.historys.Data.Items.length
          )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onMoreHistyory())),
                          style: {"text-align":"center","width":"100%","line-height":"24px","height":"24px","background-color":"#00a9fc","color":"#fff","font-size":"12px","cursor":"pointer"}
                        }, [
                          _createTextVNode(" 查看更多 "),
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ArrowDownBold)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])), [
      [
        _directive_loading,
        _ctx.isLoading,
        void 0,
        {
          fullscreen: true,
          lock: true
        }
      ]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.executorRuleFormVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.executorRuleFormVisible) = $event)),
      "show-close": false,
      style: {"width":"40%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_100,
        _createElementVNode("div", _hoisted_101, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          ref: "$executorRuleForm",
          modelValue: _ctx.executorRuleForm,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.executorRuleForm) = $event)),
          fix: true
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'ExecutorName')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      placeholder: "请填写",
                      disabled: false,
                      modelValue: _ctx.executorRuleForm.Data.ExecutorName,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.executorRuleForm.Data.ExecutorName) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'ExecutorPhone')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      placeholder: "请填写",
                      disabled: false,
                      modelValue: _ctx.executorRuleForm.Data.ExecutorPhone,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.executorRuleForm.Data.ExecutorPhone) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_102, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.executorBottomButtons,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.executorBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickExecutor
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.customsCodeRuleFormVisible,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.customsCodeRuleFormVisible) = $event)),
      "show-close": false,
      style: {"width":"40%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_103,
        _createElementVNode("div", _hoisted_104, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          ref: "$customsCodeRuleForm",
          modelValue: _ctx.customsCodeRuleForm,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.customsCodeRuleForm) = $event)),
          fix: true
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'CustomsCode')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_input, {
                      modelValue: _ctx.customsCodeRuleForm.Data.CustomsCode,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.customsCodeRuleForm.Data.CustomsCode) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_105, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.customsCodeBottomButtons,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.customsCodeBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickCustomsCode
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.releaseTimeRuleFormVisible,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.releaseTimeRuleFormVisible) = $event)),
      "show-close": false,
      style: {"width":"40%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_106,
        _createElementVNode("div", _hoisted_107, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          ref: "$releaseTimeRuleForm",
          modelValue: _ctx.releaseTimeRuleForm,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.releaseTimeRuleForm) = $event)),
          fix: true
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'ReleaseTime')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.releaseTimeRuleForm.Data.ReleaseTime,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.releaseTimeRuleForm.Data.ReleaseTime) = $event)),
                      style: {"width":"100% !important"},
                      type: "datetime",
                      placeholder: "请选择",
                      format: "YYYY/MM/DD HH:mm",
                      "default-time": _ctx.defaultTime
                    }, null, 8, ["modelValue", "default-time"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_108, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.releaseTimeBottomButtons,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.releaseTimeBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickReleaseTime
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.BLNOForm.Data.Visible,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.BLNOForm.Data.Visible) = $event)),
      "show-close": false,
      style: {"width":"40%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_109,
        _createElementVNode("div", _hoisted_110, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          ref: "$BLNOForm",
          modelValue: _ctx.BLNOForm,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.BLNOForm) = $event)),
          fix: true
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'BLNO')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.BLNOForm.Data.BLNO,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.BLNOForm.Data.BLNO) = $event)),
                      placeholder: "请填写",
                      onChange: _ctx.onChangeBLNO
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_111, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.BLNOBottomButtons,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.BLNOBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickBLNO
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.BatchBLNOForm.Visible,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.BatchBLNOForm.Visible) = $event)),
      "show-close": false,
      style: {"width":"50%"},
      top: "10px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_112,
        _createElementVNode("div", _hoisted_113, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ruleFormBatchBLNO",
          model: _ctx.BatchBLNOForm,
          "label-width": "150px",
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_table, {
                ref: "customsPackageTable",
                data: _ctx.BatchBLNOForm.Items,
                "max-height": _ctx.widthHeight,
                onSelectionChange: _ctx.handleSelectionChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "Code",
                    label: "资料编号"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(scope.row.OrderDepartureId),
                        style: {"width":"100% !important","word-break":"break-all","overflow":"hidden","height":"26px","line-height":"26px"},
                        title: scope.row.Code
                      }, [
                        _createElementVNode("span", {
                          style: _normalizeStyle(scope.row.IsSelected == true
                  ? 'font-weight:900;color:#00a9fb;'
                  : ''
                  )
                        }, _toDisplayString(_ctx.isString(scope.row.Code)), 5)
                      ], 10, _hoisted_114)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "ClientCompany",
                    label: "委托人"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        style: {"width":"100% !important","word-break":"break-all","overflow":"hidden","height":"26px","line-height":"26px"},
                        title: scope.row.ClientCompany
                      }, _toDisplayString(_ctx.isString(scope.row.ClientCompany)), 9, _hoisted_115)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, { prop: "BLNO" }, {
                    header: _withCtx(() => [
                      _hoisted_116,
                      _createTextVNode(" 提运单号 ")
                    ]),
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_117, [
                        _createVNode(_component_el_form_item, {
                          "label-width": "0px",
                          label: "",
                          rules: _ctx.rules.BLNO,
                          prop: 'Items.' + scope.$index + '.BLNO'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_miezz_input, {
                              placeholder: "请填写",
                              onChange: ($event: any) => (_ctx.onChangeBatchBLNO(scope.$index)),
                              modelValue: scope.row.BLNO,
                              "onUpdate:modelValue": ($event: any) => ((scope.row.BLNO) = $event)
                            }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "prop"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "max-height", "onSelectionChange"])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createElementVNode("div", _hoisted_118, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.BatchBLNOBottomButtons,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.BatchBLNOBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickBatchBLNO
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.addRuleFormVisible,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.addRuleFormVisible) = $event)),
      "show-close": false,
      style: {"width":"40%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_119,
        _createElementVNode("div", _hoisted_120, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_miezz_form, {
          ref: "$addRuleForm",
          modelValue: _ctx.addRuleForm,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.addRuleForm) = $event)),
          fix: true,
          key: _ctx.clientRandom
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'IsTax' && _ctx.service == 10)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.addRuleForm.Data.IsTax,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.addRuleForm.Data.IsTax) = $event)),
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (item.Prop == 'ClearCustomsHeader' && _ctx.service == 20)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.addRuleForm.Data.ClearCustomsHeader,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.addRuleForm.Data.ClearCustomsHeader) = $event)),
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options1, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (
          item.Prop == 'ClientCompanyId' &&
          (_ctx.addRuleForm.Data.IsTax == true ||
            _ctx.addRuleForm.Data.ClearCustomsHeader == 1)
        )
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.addRuleForm.Data.ClientCompanyId,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.addRuleForm.Data.ClientCompanyId) = $event)),
                      filterable: "",
                      placeholder: "请选择",
                      onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.onChangeClientCompanyId()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientCompanys, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.Value,
                            label: item.Label,
                            value: item.Value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true),
            (
          item.Prop == 'OrderPoolId' &&
          (_ctx.addRuleForm.Data.IsTax == true ||
            _ctx.addRuleForm.Data.ClearCustomsHeader == 1)
        )
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 3,
                  prop: item.Prop,
                  label: item.Label
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.addRuleForm.Data.OrderPoolId,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.addRuleForm.Data.OrderPoolId) = $event)),
                      disabled: _ctx.addRuleForm.Data.ClientCompanyId != null &&
            _ctx.addRuleForm.Data.ClientCompanyId != undefined
            ? false
            : true
            
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pools, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.Value,
                            label: item.Label,
                            value: item.Value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "disabled"])
                  ]),
                  _: 2
                }, 1032, ["prop", "label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])),
        _createElementVNode("div", _hoisted_121, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.addBottomButtons,
            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.addBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickAdd
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.exportAnnexRuleFormVisible,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.exportAnnexRuleFormVisible) = $event)),
      "show-close": false,
      style: {"width":"40%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_122, [
          (_ctx.isEdit == true)
            ? (_openBlock(), _createElementBlock("span", _hoisted_123, "附件"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_124, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        (
      _ctx.orderDepartureAnnexs != null &&
      _ctx.orderDepartureAnnexs != undefined &&
      _ctx.orderDepartureAnnexs.length > 0 &&
      _ctx.isEdit == false
    )
          ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "文件",
                          "label-width": "100px"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("table", _hoisted_125, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_126, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderDepartureAnnexs, (p, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      style: {"line-height":"40px"},
                                      key: index
                                    }, [
                                      _createElementVNode("a", {
                                        style: {"color":"#409eff","text-decoration":"none"},
                                        target: "_blank",
                                        href: p.url
                                      }, _toDisplayString(p.name), 9, _hoisted_127)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.exportAnnexRuleForm.Data.Mode == 20 && _ctx.isEdit == false)
          ? (_openBlock(), _createBlock(_component_el_row, {
              key: 1,
              style: {"margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("table", _hoisted_128, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_129, [
                          _createElementVNode("div", _hoisted_130, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Document)
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" 报关资料 ")
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_131, [
                          _createElementVNode("div", _hoisted_132, [
                            _createElementVNode("a", {
                              style: {"color":"#409eff","text-decoration":"none"},
                              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.onCustoms(_ctx.exportAnnexRuleForm.Data.OrderDepartureId))),
                              href: "javascript:;"
                            }, "预览")
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isEdit == true)
          ? (_openBlock(), _createBlock(_component_miezz_form, {
              key: 2,
              ref: "$exportAnnexRuleForm",
              modelValue: _ctx.exportAnnexRuleForm,
              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.exportAnnexRuleForm) = $event)),
              fix: true,
              "label-width": 100
            }, {
              "form-item": _withCtx(({ item }) => [
                (
          item.Prop == 'Prerecording' && _ctx.exportAnnexRuleForm.Data.Mode == 10
        )
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      label: _withCtx(() => [
                        (_ctx.isEdit == true)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              style: _normalizeStyle((_ctx.service == 20 ||
              (_ctx.service == 10 && _ctx.exportAnnexRuleForm.Data.IsTax == true)) &&
              (_ctx.list.Data.AddDeparturePortDeclareCustoms == true ||
                _ctx.list.Data.AddDestinationPortClearCustoms == true) &&
              (_ctx.exportAnnexRuleForm.Data.Data == null ||
                _ctx.exportAnnexRuleForm.Data.Data == undefined ||
                _ctx.exportAnnexRuleForm.Data.Data.length <= 0)
              ? 'color:red;font-weight:900;'
              : ''
              )
                            }, " 资料 ", 4))
                          : (_openBlock(), _createElementBlock("span", _hoisted_133, " 资料 "))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.exportAnnexRuleForm.Data.Data,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.exportAnnexRuleForm.Data.Data) = $event)),
                          path: "customs/orderDeparture",
                          accept: "file/*",
                          prop: "Url",
                          maxSize: 10 * 1024 * 1024
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true),
                (
          item.Prop == 'Prerecording' && _ctx.exportAnnexRuleForm.Data.Mode == 10
        )
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      label: _withCtx(() => [
                        (_ctx.isEdit == true)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              style: _normalizeStyle((_ctx.service == 20 ||
              (_ctx.service == 10 && _ctx.exportAnnexRuleForm.Data.IsTax == true)) &&
              _ctx.list.Data.FeedbackDeparturePortDeclareCustoms == true &&
              (_ctx.exportAnnexRuleForm.Data.Prerecording == null ||
                _ctx.exportAnnexRuleForm.Data.Prerecording == undefined ||
                _ctx.exportAnnexRuleForm.Data.Prerecording.length <= 0)
              ? 'color:red;font-weight:900;'
              : ''
              )
                            }, " 预录单 ", 4))
                          : (_openBlock(), _createElementBlock("span", _hoisted_134, " 预录单 "))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.exportAnnexRuleForm.Data.Prerecording,
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.exportAnnexRuleForm.Data.Prerecording) = $event)),
                          path: "customs/orderDeparture",
                          accept: "file/*",
                          prop: "Url",
                          maxSize: 10 * 1024 * 1024
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true),
                (item.Prop == 'Release' && _ctx.exportAnnexRuleForm.Data.Mode == 10)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      label: _withCtx(() => [
                        (_ctx.isEdit == true)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              style: _normalizeStyle((_ctx.service == 20 ||
              (_ctx.service == 10 && _ctx.exportAnnexRuleForm.Data.IsTax == true)) &&
              _ctx.list.Data.FeedbackDeparturePortDeclareCustoms == true &&
              (_ctx.exportAnnexRuleForm.Data.Release == null ||
                _ctx.exportAnnexRuleForm.Data.Release == undefined ||
                _ctx.exportAnnexRuleForm.Data.Release.length <= 0)
              ? 'color:red;font-weight:900;'
              : ' '
              )
                            }, " 放行通知书 ", 4))
                          : (_openBlock(), _createElementBlock("span", _hoisted_135, " 放行通知书 "))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.exportAnnexRuleForm.Data.Release,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.exportAnnexRuleForm.Data.Release) = $event)),
                          path: "customs/orderDeparture",
                          accept: "file/*",
                          prop: "Url",
                          maxSize: 10 * 1024 * 1024
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true),
                (item.Prop == 'Other' && _ctx.exportAnnexRuleForm.Data.Mode == 10)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.exportAnnexRuleForm.Data.Other,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.exportAnnexRuleForm.Data.Other) = $event)),
                          path: "customs/orderDeparture",
                          accept: "file/*",
                          prop: "Url",
                          maxSize: 10 * 1024 * 1024
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_136, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.exportAnnexBottomButtons,
            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.exportAnnexBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickExportAnnex
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.importAnnexRuleFormVisible,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.importAnnexRuleFormVisible) = $event)),
      "show-close": false,
      style: {"width":"40%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_137,
        _createElementVNode("div", _hoisted_138, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        (
      _ctx.orderDepartureAnnexs != null &&
      _ctx.orderDepartureAnnexs != undefined &&
      _ctx.orderDepartureAnnexs.length > 0 &&
      _ctx.isEdit == false
    )
          ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("table", _hoisted_139, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_140, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderDepartureAnnexs, (p, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              style: {"line-height":"40px"},
                              key: index
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Document)
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(p.name), 1)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("td", _hoisted_141, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderDepartureAnnexs, (p, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              style: {"line-height":"40px"},
                              key: index
                            }, [
                              _createElementVNode("a", {
                                style: {"color":"#409eff","text-decoration":"none"},
                                target: "_blank",
                                href: p.url
                              }, "预览", 8, _hoisted_142)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isEdit == true)
          ? (_openBlock(), _createBlock(_component_miezz_form, {
              key: 1,
              ref: "$importAnnexRuleForm",
              modelValue: _ctx.importAnnexRuleForm,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.importAnnexRuleForm) = $event)),
              fix: true,
              "label-width": 100
            }, {
              "form-item": _withCtx(({ item }) => [
                (item.Prop == 'Prerecording')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      label: _withCtx(() => [
                        (_ctx.isEdit == true)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              style: _normalizeStyle((_ctx.service == 20 ||
              (_ctx.service == 10 && _ctx.importAnnexRuleForm.Data.IsTax == true)) &&
              (_ctx.list.Data.AddDeparturePortDeclareCustoms == true ||
                _ctx.list.Data.AddDestinationPortClearCustoms == true) &&
              (_ctx.importAnnexRuleForm.Data.Data == null ||
                _ctx.importAnnexRuleForm.Data.Data == undefined ||
                _ctx.importAnnexRuleForm.Data.Data.length <= 0)
              ? 'color:red;font-weight:900;'
              : ''
              )
                            }, " 资料 ", 4))
                          : (_openBlock(), _createElementBlock("span", _hoisted_143, " 资料 "))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.importAnnexRuleForm.Data.Data,
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.importAnnexRuleForm.Data.Data) = $event)),
                          path: "customs/orderDeparture",
                          accept: "file/*",
                          prop: "Url",
                          maxSize: 10 * 1024 * 1024
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true),
                (item.Prop == 'Prerecording')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      label: _withCtx(() => [
                        (_ctx.isEdit == true)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              style: _normalizeStyle(_ctx.list.Data.FeedbackDestinationPortClearCustoms == true &&
              (_ctx.importAnnexRuleForm.Data.Prerecording == null ||
                _ctx.importAnnexRuleForm.Data.Prerecording == undefined ||
                _ctx.importAnnexRuleForm.Data.Prerecording.length <= 0)
              ? 'color:red;font-weight:900;'
              : ''
              )
                            }, " 预录单 ", 4))
                          : (_openBlock(), _createElementBlock("span", _hoisted_144, " 预录单 "))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.importAnnexRuleForm.Data.Prerecording,
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.importAnnexRuleForm.Data.Prerecording) = $event)),
                          path: "customs/orderDeparture",
                          accept: "file/*",
                          prop: "Url",
                          maxSize: 10 * 1024 * 1024
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true),
                (item.Prop == 'Release')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      label: _withCtx(() => [
                        (_ctx.isEdit == true)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              style: _normalizeStyle(_ctx.list.Data.FeedbackDestinationPortClearCustoms == true &&
              (_ctx.importAnnexRuleForm.Data.Release == null ||
                _ctx.importAnnexRuleForm.Data.Release == undefined ||
                _ctx.importAnnexRuleForm.Data.Release.length <= 0)
              ? 'color:red;font-weight:900;'
              : ' '
              )
                            }, " 放行通知书 ", 4))
                          : (_openBlock(), _createElementBlock("span", _hoisted_145, " 放行通知书 "))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.importAnnexRuleForm.Data.Release,
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.importAnnexRuleForm.Data.Release) = $event)),
                          path: "customs/orderDeparture",
                          accept: "file/*",
                          prop: "Url",
                          maxSize: 10 * 1024 * 1024
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true),
                (item.Prop == 'Other')
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      prop: item.Prop,
                      label: item.Label
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.importAnnexRuleForm.Data.Other,
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.importAnnexRuleForm.Data.Other) = $event)),
                          path: "customs/orderDeparture",
                          accept: "file/*",
                          prop: "Url",
                          maxSize: 10 * 1024 * 1024
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "label"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_146, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.importAnnexBottomButtons,
            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.importAnnexBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickImportAnnex
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_supplier, {
      ref: "Supplier",
      isLock: _ctx.isLock,
      isDetail: _ctx.isSupplier,
      onOnSelectSupplier: _ctx.onSelectSupplier
    }, null, 8, ["isLock", "isDetail", "onOnSelectSupplier"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalProcess,
      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.modalProcess) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_timeline, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processList, (item, i) => {
              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                key: i,
                timestamp: item.Date,
                placement: "top",
                type: "primary",
                size: "normal"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    style: _normalizeStyle(item.Code.indexOf('查验')>-1? 'color:red':'')
                  }, _toDisplayString(item.Code) + " - " + _toDisplayString(item.Content), 5)
                ]),
                _: 2
              }, 1032, ["timestamp"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}